import { Injectable } from "@angular/core";
import { CHttp } from "../../core/services/chttp.service";
import { config } from "../../app.config";
import { AbTest } from "../ab-tests.interfaces";

@Injectable()
export class AbTestsService {

  constructor(private http: CHttp) { }

  public getAllAbTests() {
    return this.http.get(config.api_url + "ab-testing");
  }

  public getAbTestById(id: string) {
    return this.http.get(config.api_url + "ab-testing/" + id);
  }

  public getAbTestForUser(id: string) {
    return this.http.get(config.api_url + "ab-testing/variants/" + id);
  }

  public createAbTest(data: AbTest) {
    return this.http.post(config.api_url + "ab-testing", data);
  }

  public updateAbTest(id: string, data: AbTest) {
    return this.http.put(config.api_url + "ab-testing/" + id, data);
  }

  public deleteAbTest(id: string) {
    return this.http.delete(config.api_url + "ab-testing/" + id);
  }
}



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/ab-tests/services/ab-tests.service.ts